module.exports = __webpack_public_path__ + "img/projects3.fc12d70d.png";